import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import {
  AbstractControl,
  CheckboxControlValueAccessor,
  FormArray,
  FormControl,
  FormControlName,
  FormGroup,
  Validators,
  FormBuilder
} from '@angular/forms';


import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { ApiService } from '../service/index'
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
  selector: 'app-warrantyregistration',
  templateUrl: './warrantyregistration.component.html',
  styleUrls: ['./warrantyregistration.component.css']
})
export class WarrantyregistrationComponent implements OnInit {
  disableSubmit:boolean = false
  waarentyForm:any;
  items:any;
  todayDate : Date = new Date();
  submitted = false;
  isBrowser : boolean;
  siteKey = environment.siteKey
  message = '';
  loadMore = false;
  location:any = [];
  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';
  tinyUrl= 'https://cosmosgranite.nyc3.cdn.digitaloceanspaces.com/igmcorp/assets/images';

  constructor(private fb: FormBuilder,@Inject(PLATFORM_ID) private platformId, private api: ApiService, private reCaptchaV3Service: ReCaptchaV3Service) { 
    this.isBrowser = isPlatformBrowser(platformId) ?isPlatformBrowser(platformId): true;

  }

  ngOnInit(): void {
    
    this.waarentyForm = this.fb.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [ Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(10),Validators.maxLength(13)]],
      street: ['', Validators.required],
      city: ['',[Validators.required, Validators.pattern("^[A-Za-z ]+$")]],
      zipcode: ['', Validators.required],
      country: ['', Validators.required],
      aptno: [''],
      subdivision: [''],
      // invoice_number:['',[Validators.required]],
      location: ['', Validators.required],
      installation_date: ['', Validators.required],
      total_square_footage: ['', Validators.required],
      application: [''],
      installation_type: ['', Validators.required],
      company_name: ['', Validators.required],
      f_city: [''],
      f_street: [''],
      f_zipcode: [''],
      f_state: [''],
      f_country: [''],
      product: new FormArray([]),
      hp_field: [''],
    });
    this.waarentyForm.get('installation_date').patchValue(this.formatDate(new Date()));
    this.addItem({})
    this.getLocation()

  }


  get f() { return this.waarentyForm.controls; }
	addItem(data:any={}): void {
		this.items = this.waarentyForm.get('product') as FormArray;
		this.items.push(this.createItem(data));
	  }
	remove(i:any): void {
	this.items = this.waarentyForm.get('product') as FormArray;
	this.items.removeAt(i);
	}
	createItem(data:any): FormGroup {
		return this.fb.group({
		  color: [''],
		  serial_number: [' ', Validators.required ],


		});
  }
  trackByFn(index: any, item: any) {
    return index;
  }
  // getPhonesFormControls(): AbstractControl[] {
  //   return (<FormArray> this.waarentyForm.get('product')).controls
  // }

  private formatDate(date: any) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  submit(data: any) {
    this.submitted = true;
    if (this.waarentyForm.invalid) {
      return;
    }
    this.disableSubmit = true

    this.reCaptchaV3Service.execute(this.siteKey, 'WarentyForm', (token) => {

      data['serial_number1'] = []
      data['color1'] = []
      data.product.map((f: any) => {
        data['serial_number1'].push(f.serial_number)
        data['color1'].push(f.color)
      })
      data['color'] = data['color1']
      data['serial_number'] = data['serial_number1']

      let obj = {
        firstname: data.firstname,
        lastname: data.lastname,
        phoneNumber: data.phoneNumber,
        aptno: data.aptno,
        street: data.street,
        zipcode: data.zipcode,
        city: data.city,
        country: data.country,
        subdivision: data.subdivision,
        email: data.email,
        location: data.location,
        installation_date: this.formatDateToDDMMYYYY(data.installation_date),
        serial_number: data.serial_number,
        color: data.color,
        total_square_footage: data.total_square_footage,
        application: data.application,
        installation_type: data.installation_type,
        company_name: data.company_name,
        f_street: data.f_street,
        f_city: data.f_city,
        f_zipcode: data.f_zipcode,
        f_state: data.f_state,
        f_country: data.f_country,
        website: "coalesce-quartz",
        hp_field: data.hp_field,
        captcha: token
      }
      // console.log(obj)

      this.loadMore = true;
      this.api.fetchDataIgm('warranty-registration', obj, 'POST').subscribe(res => {
        this.loadMore = false;
        this.disableSubmit = false
        if (res.status == 1) {
          this.waarentyForm.reset();
          this.submitted = false;
          this.message = res.message
          this.waarentyForm.patchValue({
            installation_date: this.formatDate(new Date())
          })

          this.removeformarray()
          setTimeout(() => {
            this.message = '';
          }, 10000)
        } else {
          this.message = res.message
          this.submitted = false;
          setTimeout(() => {
            this.message = '';
          }, 10000)

        }
      })
    }, {
      useGlobalDomain: false
    });

  }

  getLocation() {
    this.api.fetchDataIgm('allLocation-coalesce-quartz',{},'POST').subscribe(
      res => {
        if(res['status'] == 1) {
          this.location =   res['location'];
        } else {
          this.location =  [];
        }
      }
    )
  }

  removeformarray(): void {
    this.items = this.waarentyForm.get('product') as FormArray;
    // console.log(this.items.length)
    let length = this.items.length;
    for( let i=1; i < length; i++){
      this.items.removeAt(i);
    }
  }
  formatDateToDDMMYYYY(dateStr: string): string {
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
}
}


